/**
 * UTM Tracking
 * List of all utm params to check
 */
 var utm_tracking_params = [
	'utm_source', 
	'utm_medium',
	'utm_campaign',
	'utm_content',
	'utm_term',
];

/**
 * Get URL Parameters
 */
function GetURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) 
    {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) 
        {
            return sParameterName[1];
        }
    }
}

/**
 * Cookie functions
 */
 function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
function eraseCookie(name) {   
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


// Doc Ready
$(function() {

	/**
	 * Set Cookies for UTM parameters
	 * 
	 * Check if the page has a query string & has UTM vars,
	 * Then store values in cookies
	 */
	/* if(document.location.search.length) {

		$.each(utm_tracking_params,function(index, value) {

			var url_param = GetURLParameter(value);

			if( typeof url_param !== 'undefined' ) {	

				// set the value in the field
				if( $('#webform-client-form-976').length || $('#webform-client-form-974').length || $('#webform-client-form-981').length || $('#webform-client-form-1006').length || $('#webform-client-form-993').length ) {
					$(".webform-client-form input[name='submitted["+value+"]']").val( url_param );
				}			
				
				setCookie(value, url_param, 3); // set cookie
				
			}
		});

	} */

	/**
	 * Thank you pages
	 * Clear UTM tracking cookies
	 */
	// if( $('body.page-node-977').length || $('body.page-node-997').length || $('body.page-node-998').length || $('body.page-node-1007').length ) {
	// 	$.each(utm_tracking_params,function(index, value) {
	// 		eraseCookie(value);
	// 	});
	// }


});